// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1YV3Q","form":"styles_form__3A7PM"};